module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-217.54c9b5b9.svg";